import logoLead from '@/assets/logo/lighthouse1_free.png';
import logoLeadText from '@/assets/logo/lighthouse1_free_text.png';
import panelLogo from '@/assets/logo/lead-logo.png';

import type { Brand } from './types';

export const lead: Brand = {
  key: 'lead',
  appType: 'LEAD',
  name: 'LEAD',
  shortName: 'LEAD',
  emblem: 'LEAD',
  productName: 'JobIQ',
  productBadge: 'JQ',
  legalName: 'JobIQ AG, Zürich',
  byline: 'JobIQ AG',
  logos: { main: logoLead, text: logoLeadText, panel: panelLogo, panelInvert: false },
  wordmark: null,
  panelHeadlineKey: 'auth.panel.headline',
  theme: {},
  // placeholder links until the legal page URLs are known
  legalLinks: { imprint: '#', privacy: '#', terms: '#' },
};
